import { Grid } from '@mui/material';
import { BarCharts } from './BarCharts';
import { TodayWeekMonth } from './TodayWeekMonth/TodayWeekMonth';

type BarData = {
  xAxisName: string;
  uv: number;
  [key: string]: number | string | undefined;
  amt: number;
}[];

interface HomeChartsProps {
  loading: boolean;
  error: boolean;
  today?: string;
  weekly?: string;
  monthly?: string;
  todayTitle?: string;
  weeklyTitle?: string;
  monthlyTitle?: string;
  barData?: BarData;
  barValueKey?: string;
  barTitle?: string;
  valueFormatter?: (value: any) => string;
}

export const HomeCharts = ({
  loading,
  error,
  today,
  weekly,
  monthly,
  todayTitle,
  weeklyTitle,
  monthlyTitle,
  barData,
  barValueKey,
  barTitle,
  valueFormatter,
}: HomeChartsProps) => {
  return (
    <Grid
      container
      spacing={1}
      sx={{
        width: '100%',
        maxWidth: '100%',
        margin: 0,
        boxSizing: 'border-box',
      }}
    >
      {[today, weekly, monthly].filter((item) => item !== undefined).length >
        0 && (
        <Grid
          item
          xs={12}
          sx={{
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
          }}
        >
          <TodayWeekMonth
            today={today}
            weekly={weekly}
            monthly={monthly}
            todayTitle={todayTitle}
            weeklyTitle={weeklyTitle}
            monthlyTitle={monthlyTitle}
            loading={loading}
            error={error}
          />
        </Grid>
      )}

      {barData && barValueKey && barTitle && (
        <Grid
          item
          xs={12}
          sx={{
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
          }}
        >
          <BarCharts
            title={barTitle}
            data={barData}
            error={error}
            loading={loading}
            xKey="xAxisName"
            valueFormatter={valueFormatter}
            valueKey={barValueKey}
            sx={{
              borderRadius: '10px',
              paddingRight: { xs: 1, sm: 3 },
              boxSizing: 'border-box',
              width: '100%',
              maxWidth: '100%',
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};
